import MyDealerContainer from "./my-dealer.container";

export default MyDealerContainer;